module.exports = __webpack_public_path__ + "static/media/BASIS-WATERNIVEAU_02.241b73a5.apng";